<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      loading-text="Cargando..."
      class="elevation-1"
      item-key="id"
      :footer-props="footerOptions"
    >
      <template v-slot:top>
        <v-toolbar
          flat
          color="white"
        >
          <back-button v-if="back" />
          <v-toolbar-title v-html="title" />
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-spacer />
          <slot name="filters" />
          <v-spacer />
          <v-text-field
            v-on:input="debounceInput"
            label="Buscar"
            single-line
            hide-details
          />
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-btn
            v-if="!readonly && can(permisosNuevoRegistro)"
            :color="themeColor"
            class="white--text"
            @click="newItem()"
          >
            Nuevo Registro
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.active="{ item }">
        <v-switch
          :color="themeColor"
          v-model="item.active"
          :loading="toggleStatus"
          @click.prevent="openModalStatus(item)"
        />
      </template>
      <template v-slot:item.notify_status="{ item }">
        <v-chip
          :color="item.notify_status === 1 ? 'green' : 'orange'"
          dark
          small
        >
          {{ item.notify_status === 1 ? 'Leída' : 'Pendiente' }}
        </v-chip>
      </template>
      <slot name="filter">
        Default
      </slot>
      <template v-slot:item.type_app="{ item }">
        <span v-if="item.type_app == 1">INTEGRACIÓN</span>
        <span v-else>APP</span>
      </template>
      <template v-slot:item.result_code="{ item }">
        <v-chip
          :color="getColor(item.result_code)"
          dark
        >
          <span v-if="item.result_code.indexOf('0260') !== -1">ACEPTADO</span>
          <span v-else>RECHAZADO</span>
        </v-chip>
      </template>
      <template v-slot:item.type="{ item }">
        <span v-if="item.type == 1">FACTURA</span>
        <span v-else-if="item.type == 2">IMPORTACIÓN</span>
        <span v-else-if="item.type == 3">EXPORTACIÓN</span>
        <span v-else-if="item.type == 4">REFERENTE (NC)</span>
        <span v-else-if="item.type == 5">REFERENTE (ND)</span>
        <span v-else-if="item.type == 6">NOTA DE CRÉDITO</span>
        <span v-else-if="item.type == 7">NOTA DE DÉBITO</span>
        <span v-else-if="item.type == 8">ZONA FRANCA</span>
        <span v-else-if="item.type == 9">REEMBOLSO</span>
      </template>
      <template v-slot:item.action_documents="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              :color="themeColor"
              dark
              @click="getXML(item)"
              v-on="on"
              :loading="busy"
            >
              mdi-file-xml
            </v-icon>
          </template>
          <span>XML</span>
        </v-tooltip>
      </template>
      <template v-slot:item.action="{ item }">
        <slot
          v-if="hasActionsSlot()"
          name="actions"
          :item="item"
        />
        <div v-else>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="!readonlyEditar && can(permisosNuevoMovimiento)"
                :color="themeColor"
                class="white--text"
                @click="openModalMovements(item)"
                v-on="on"
              >
                mdi-swap-horizontal
              </v-icon>
            </template>
            <span>Movimientos</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="!readonlyEditar && can(permisosHistorial)"
                :color="themeColor"
                class="white--text"
                @click="historyItem(item)"
                v-on="on"
              >
                mdi-file
              </v-icon>
            </template>
            <span>Historial</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="!readonlyEditar && can(permisosEditar)"
                :color="themeColor"
                class="white--text"
                @click="editItem(item)"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="!readonlyEliminar && can(permisosEliminar)"
                :color="themeColor"
                class="white--text"
                @click="openModalDelete(item)"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:footer>
        <slot name="footer" />
      </template>
      <template v-slot:no-data>
        <v-label>No se encontraron resultados.</v-label><br>
        <v-btn
          :color="themeColor"
          class="white--text"
          @click="reset"
        >
          Limpiar búsqueda
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogStatus"
      max-width="750"
    >
      <v-card>
        <v-card-title class="headline">
          ¿Estás seguro de que quieres cambiar el estado de este registro?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error darken-1"
            text
            @click="dialogStatus = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="toggleStatus"
            @click.prevent="toggleActive()"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog"
      max-width="620"
    >
      <v-card>
        <v-card-title class="headline">
          ¿Estás seguro de que quieres eliminar este registro?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red darken-1"
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="toggleStatusDelete"
            @click.prevent="deleteItem()"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogShowMovements"
        max-width="800"
      >
        <v-card>
          <v-card-title class="headline">
            Realizar Movimiento {{ titleAccount }}
          </v-card-title>
          <v-container>
            <v-form
              ref="form"
              lazy-validation
              @submit.prevent="reset"
              @keydown="form.onKeydown($event)"
            >
              <v-card-text>
                <v-select
                  v-model="form.type_movement"
                  :items="movement_types"
                  :rules="[rules.required]"
                  label="Tipo de Movimiento"
                  @change="showServices"
                  required
                />
              </v-card-text>
              <v-row>
                <v-col v-if="item">
                  <v-card-text>
                    <v-text-field
                      v-model="item.folios"
                      label="Folios Disponibles"
                      maxlength="8"
                      readonly
                    />
                  </v-card-text>
                </v-col>
                <v-col v-if="form.type_movement == 3">
                  <v-card-text>
                    <v-text-field
                      v-model="form.folios"
                      label="Cantidad de Folios"
                      :rules="[rules.required, rules.numeric]"
                      maxlength="8"
                      required
                    />
                  </v-card-text>
                </v-col>
                <v-col cols="6" v-if="form.type_movement == 3">
                  <v-card-text>
                    <v-text-field
                      v-model="form.description"
                      label="Concepto"
                      maxlength="150"
                      required
                    />
                  </v-card-text>
                </v-col>
              </v-row>
              <v-card-text v-if="form.type_movement == 4">
                <v-select
                  v-model="form.service_id"
                  :rules="[rules.required]"
                  :items="servicesList"
                  item-value="id"
                  label="Servicios de Licencias"
                  required
                  @change="onLicenseCorporativoChange"
                >
                  <template v-slot:selection="data">
                    <v-chip>
                      <span>
                        {{ data.item.servicio }} - {{ data.item.nombre }}
                        ({{ data.item.cantidad }} folios - {{ data.item.tiempo }} meses)
                      </span>
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    {{ data.item.servicio }} - {{ data.item.nombre }}
                    ({{ data.item.cantidad }} folios - {{ data.item.tiempo }} meses)
                  </template>
                </v-select>
                <v-alert
                  v-if="form.service_id && selectedCorporativoService && maxLicensesConversion > 0"
                  dense
                  outlined
                  type="info"
                  icon="mdi-information-outline"
                  class="mt-4 mb-0"
                >
                  <span class="body-2">
                    Puedes generar hasta
                    <strong class="primary--text text--darken-2">{{ maxLicensesConversion }}</strong>
                    {{ maxLicensesConversion === 1 ? 'licencia' : 'licencias' }}
                    de este tipo (según tus folios disponibles y el tipo elegido).
                  </span>
                </v-alert>
                <v-alert
                  v-else-if="form.service_id && selectedCorporativoService"
                  dense
                  outlined
                  type="error"
                  icon="mdi-alert-circle-outline"
                  class="mt-4 mb-0"
                >
                  <span class="body-2">
                    No alcanzas los folios necesarios para al menos una licencia de este tipo.
                  </span>
                </v-alert>
                <v-sheet
                  v-if="form.service_id && maxLicensesConversion > 0"
                  outlined
                  rounded
                  class="mt-4"
                >
                  <div class="px-4 pt-4 pb-2">
                    <div class="subtitle-2 font-weight-medium text--primary mb-1">
                      Cantidad de licencias a convertir
                    </div>
                    <div class="caption text--secondary mb-3">
                      Entre 1 y {{ maxLicensesConversion }} licencias
                    </div>
                    <div
                      class="license-qty-modern d-flex align-stretch mx-auto"
                    >
                      <v-btn
                        text
                        class="license-qty-modern__btn"
                        :ripple="false"
                        :disabled="(Number(licenseConversionQuantity) || 0) <= 1"
                        aria-label="Disminuir cantidad de licencias"
                        @click="adjustLicenseConversionQuantity(-1)"
                      >
                        <v-icon color="primary">
                          mdi-minus
                        </v-icon>
                      </v-btn>
                      <v-divider
                        vertical
                        class="license-qty-modern__divider"
                      />
                      <div
                        class="license-qty-modern__field-wrap d-flex align-center justify-center flex-grow-1 px-1"
                      >
                        <v-text-field
                          v-model.number="licenseConversionQuantity"
                          class="license-qty-field"
                          type="number"
                          :min="1"
                          :max="maxLicensesConversion"
                          :rules="[rules.required, validateLicenseConversionQty]"
                          solo
                          flat
                          dense
                          single-line
                          color="primary"
                          @input="onLicenseConversionQtyInput"
                          @blur="clampLicenseConversionQuantity"
                        />
                      </div>
                      <v-divider
                        vertical
                        class="license-qty-modern__divider"
                      />
                      <v-btn
                        text
                        class="license-qty-modern__btn"
                        :ripple="false"
                        :disabled="(Number(licenseConversionQuantity) || 0) >= maxLicensesConversion"
                        aria-label="Aumentar cantidad de licencias"
                        @click="adjustLicenseConversionQuantity(1)"
                      >
                        <v-icon color="primary">
                          mdi-plus
                        </v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <v-divider />
                  <div
                    class="px-4 py-3 d-flex justify-space-between align-center grey lighten-4"
                  >
                    <span class="body-2 font-weight-medium text--secondary">
                      Total de folios a usar
                    </span>
                    <span class="title primary--text font-weight-bold mb-0">
                      {{ form.folios || '—' }}
                    </span>
                  </div>
                </v-sheet>
              </v-card-text>
              <v-row>
                <v-col cols="9">
                  <v-card-text v-if="form.type_movement == 3">
                    <v-text-field
                      v-model="form.account_ruc_dealer"
                      label="No. Cuenta o Ruc del Distribuidor"
                      maxlength="150"
                      required
                      @input="verifyAccountsDealer"
                    />
                  </v-card-text>
                </v-col>
                <v-col cols="3">
                  <v-tooltip bottom v-if="form.type_movement == 3">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :color="themeColor"
                        dark
                        @click="searchDealerAccount"
                        v-on="on"
                        :loading="searching || form.busy"
                      >
                        <v-icon
                          text
                        >
                          mdi-credit-card-search
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row  v-if="form.type_movement == 3">
                <v-col cols="4">
                  <v-card-text>
                    <v-text-field
                      v-model="dealer.razonSocial"
                      label="Razón Social"
                      placeholder="Distribuidor S.A."
                      readonly
                    />
                  </v-card-text>
                </v-col>
                <v-col cols="4">
                  <v-card-text>
                    <v-text-field
                      v-model="dealer.ruc"
                      label="RUC"
                      placeholder="155596713-2-2015"
                      readonly
                    />
                  </v-card-text>
                </v-col>
                <v-col cols="4">
                  <v-card-text>
                    <v-text-field
                      v-model="dealer.account_number"
                      label="No. Cuenta"
                      placeholder="CE6842F4-15CE-49FB-8F76-AFDA292202B9"
                      readonly
                    />
                  </v-card-text>
                </v-col>
              </v-row>
              <v-row v-if="form.type_movement == 5">
                <v-card-text>
                  <v-select
                      v-model="form.service_id"
                      :rules="[rules.required]"
                      :items="servicesDealerList"
                      item-value="id"
                      label="Servicios de Licencias"
                      required
                      @change="setFoliosQuantityDealer"
                  >
                      <template v-slot:selection="data">
                        <v-chip
                          color="green"
                          dark
                        >
                          <span>
                            {{ data.item.servicio }} - {{ data.item.nombre }}
                            ({{ data.item.tiempo }} meses)
                          </span>
                        </v-chip>
                      </template>
                      <template v-slot:item="data">
                          {{ data.item.servicio }} - {{ data.item.nombre }}
                          ({{ data.item.tiempo }} meses)
                      </template>
                  </v-select>
                </v-card-text>
              </v-row>
            </v-form>
          </v-container>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error darken-1"
              text
              @click="dialogShowMovements = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="form.busy"
              :disabled="disabledAcceptTransaccion"
              @click.prevent="generateMovement()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import * as _ from 'underscore';
  import { mapGetters } from 'vuex';
  import Form from 'vform';
  import BackButton from './BackButton';

  export default {
    components: { BackButton },
    props: {
      headers: {
        type: Array,
        required: true,
      },
      apiURL: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      readonly: {
        type: Boolean,
        required: false,
        default: false,
      },
      readonlyEditar: {
        type: Boolean,
        required: false,
        default: false,
      },
      readonlyEliminar: {
        type: Boolean,
        required: false,
        default: false,
      },
      permisosNuevoRegistro: {
        type: String,
        required: false,
      },
      permisosEditar: {
        type: String,
        required: false,
      },
      permisosEliminar: {
        type: String,
        required: false,
      },
      permisosNuevoMovimiento: {
        type: String,
        required: false,
      },
      permisosHistorial: {
        type: String,
        required: false,
      },
      permisosMovimientosCorporativos: {
        type: Array,
        required: false,
      },
      readonlyDate: {
        type: Boolean,
        required: false,
        default: false,
      },
      back: {
        type: Boolean,
        required: false,
        default: false,
      },
      backURL: {
        type: String,
        required: false,
      },
      queryParams: {
        type: String,
        required: false,
        default: '',
      },
      message: { default: '' },
      type: { default: '' },
      bus: { default: null },
    },
    data: () => ({
      disabledAcceptTransaccion: false,
      busy: false,
      loading: false,
      dialog: false,
      dialogStatus: false,
      dialogFolios: false,
      dialogShowMovements: false,
      editedIndex: -1,
      options: {},
      search: '',
      items: [],
      totalItems: 0,
      footerOptions: { 'items-per-page-options': [10, 20, 30, 40, 50] },
      toggleStatus: false,
      toggleStatusDelete: false,
      toggleStatusFolios: false,
      deleteID: '',
      issue_date: '',
      menu2: false,
      titleAccount: '',
      licenseConversionQuantity: '',
      form: new Form({
        folios: '',
        description: '',
        type_movement: '',
        service_id: '',
        max_licenses_conversion: '',
        incoming_account_id: '',
        dealer_id: '',
        account_ruc_dealer: '',
        busy: false,
      }),
      dealer: {
        ruc: '',
        razonSocial: '',
        account_number: '',
        incoming_account_id: '',
      },
      movement_types: [
        { value: 3, text: 'Transferencia' },
        { value: 4, text: 'Conversión a Licencia' },
        { value: 5, text: 'Revertir Licencia' },
      ],
      servicesList: [],
      permisosMovimientosCorporativos: [],
      servicesDealerList: [],
      searching: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
        numeric: (v) => /^[0-9]*$/.test(v) || 'El campo solo permite caracteres numericos.',
      },
    }),
    computed: {
      ...mapGetters({
        user: 'auth/user',
        themeColor: 'theme/themeColor',
      }),
      selectedCorporativoService() {
        if (this.form.type_movement !== 4 || !this.form.service_id || !this.servicesList.length) {
          return null;
        }
        return this.servicesList.find((s) => String(s.id) === String(this.form.service_id)) || null;
      },
      maxLicensesConversion() {
        const svc = this.selectedCorporativoService;
        if (!svc || !this.item) return 0;
        const available = parseInt(this.item.folios, 10);
        const perLicense = parseInt(svc.cantidad, 10);
        if (!available || !perLicense || perLicense < 1) return 0;
        return Math.floor(available / perLicense);
      },
    },
    watch: {
      options: {
        handler() {
          this.refreshTable();
        },
        deep: true,
      },
      search: {
        handler() {
          this.refreshTable();
        },
        deep: true,
      },
      apiURL: {
        handler() {
          this.refreshTable();
        },
        deep: true,
      },
      queryParams: {
        handler() {
          this.refreshTable();
        },
        deep: true,
      },
      'form.type_movement': {
        handler(newVal, oldVal) {
          if (oldVal === 4 && newVal !== 4) {
            this.licenseConversionQuantity = '';
            this.form.folios = '';
          }
        },
      },
    },

    mounted() {
      if (this.bus) this.bus.$on('refreshTable', this.refreshTable);
      this.issue_date = this.getDate();
      if (!this.can(this.permisosMovimientosCorporativos[0])) {
        this.movement_types = this.movement_types.filter((movementType) => movementType.value !== 4);
      }
      if (!this.can(this.permisosMovimientosCorporativos[1])) {
        this.movement_types = this.movement_types.filter((movementType) => movementType.value !== 5);
      }
    },

    methods: {
      verifyAccountsDealer() {
        if (this.form.account_ruc_dealer === this.item.account_number) {
          this.$store.dispatch('notifications/show', {
            message: 'No puede colocar su numero de cuenta para realizar una transferencia.',
            type: '#ffc107',
          });
          this.form.account_ruc_dealer = '';
        }
      },
      showServices() {
        if (this.form.type_movement !== 4) {
          this.licenseConversionQuantity = '';
        }
        if (this.form.type_movement === 4 && this.servicesList.length === 0) {
          window.axios.get('/api/catalogs/getServicesForDealers?sortBy=cantidad&desc=false')
          .then((result) => {
            this.showAdd = !this.showAdd;
            this.servicesList = result.data.items;
            this.disabledAcceptTransaccion = true;
            this.form.service_id = '';
            this.licenseConversionQuantity = '';
            this.form.folios = '';
          });
        } else if (this.form.type_movement === 4 && this.servicesList.length > 0) {
          this.disabledAcceptTransaccion = true;
          this.form.service_id = '';
          this.licenseConversionQuantity = '';
          this.form.folios = '';
        } else if (this.form.type_movement === 3) {
          this.disabledAcceptTransaccion = true;
          this.form.folios = 0;
          this.form.service_id = '';
        } else if (this.form.type_movement === 5) {
          window.axios.get(`/api/catalogs/dealers/${this.user.dealer_id}/licencesCorporativos`)
          .then((result) => {
            const validItems = result.data.items.filter((service) => parseInt(service.available, 10) > 0);
            this.servicesDealerList = validItems;
            this.disabledAcceptTransaccion = true;
            this.form.service_id = '';
          });
        } else {
          this.showAdd = !this.showAdd;
          this.disabledAcceptTransaccion = false;
        }
      },
      getColorService(available) {
        if (parseInt(available, 10) >= 1) return 'green';
        return 'red';
      },
      validateLicenseConversionQty(v) {
        if (this.form.type_movement !== 4) return true;
        if (!this.form.service_id) return true;
        const max = this.maxLicensesConversion;
        if (max < 1) return 'No puedes convertir con los folios actuales.';
        const n = parseInt(v, 10);
        if (Number.isNaN(n) || n < 1) return 'Indique cuántas licencias desea generar.';
        if (n > max) {
          const label = max === 1 ? 'licencia' : 'licencias';
          return `El máximo permitido es ${max} ${label}.`;
        }
        return true;
      },
      onLicenseCorporativoChange() {
        this.$nextTick(() => {
          if (!this.selectedCorporativoService) {
            this.licenseConversionQuantity = '';
            this.form.folios = '';
            this.disabledAcceptTransaccion = false;
            return;
          }
          if (this.maxLicensesConversion < 1) {
            this.licenseConversionQuantity = '';
            this.form.folios = '';
            this.disabledAcceptTransaccion = true;
            return;
          }
          this.disabledAcceptTransaccion = false;
          this.licenseConversionQuantity = 1;
          this.syncConversionFoliosTotal();
        });
      },
      syncConversionFoliosTotal() {
        const svc = this.selectedCorporativoService;
        if (!svc) {
          this.form.folios = '';
          return;
        }
        const n = parseInt(this.licenseConversionQuantity, 10);
        if (Number.isNaN(n) || n < 1) {
          this.form.folios = '';
          return;
        }
        const perLicense = parseInt(svc.cantidad, 10);
        this.form.folios = String(n * perLicense);
      },
      onLicenseConversionQtyInput() {
        if (this.form.type_movement !== 4 || !this.selectedCorporativoService) return;
        const max = this.maxLicensesConversion;
        if (max < 1) {
          this.form.folios = '';
          return;
        }
        const raw = this.licenseConversionQuantity;
        if (raw === '' || raw === null || typeof raw === 'undefined') {
          this.form.folios = '';
          return;
        }
        const parsed = parseInt(String(raw), 10);
        if (Number.isNaN(parsed)) {
          this.form.folios = '';
          return;
        }
        const n = Math.max(1, Math.min(parsed, max));
        if (n !== parsed) {
          this.$nextTick(() => {
            this.licenseConversionQuantity = n;
          });
        }
        const perLicense = parseInt(this.selectedCorporativoService.cantidad, 10);
        this.form.folios = String(n * perLicense);
      },
      clampLicenseConversionQuantity() {
        if (this.form.type_movement !== 4 || !this.selectedCorporativoService) return;
        const max = this.maxLicensesConversion;
        if (max < 1) {
          this.licenseConversionQuantity = '';
          this.form.folios = '';
          return;
        }
        let n = parseInt(this.licenseConversionQuantity, 10);
        if (Number.isNaN(n)) {
          this.licenseConversionQuantity = 1;
          n = 1;
        } else {
          n = Math.max(1, Math.min(n, max));
          this.licenseConversionQuantity = n;
        }
        this.syncConversionFoliosTotal();
      },
      adjustLicenseConversionQuantity(delta) {
        if (this.form.type_movement !== 4 || !this.selectedCorporativoService || this.maxLicensesConversion < 1) {
          return;
        }
        let n = parseInt(this.licenseConversionQuantity, 10);
        if (Number.isNaN(n)) n = 1;
        n = Math.max(1, Math.min(n + delta, this.maxLicensesConversion));
        this.licenseConversionQuantity = n;
        this.syncConversionFoliosTotal();
      },
      setFoliosQuantityDealer() {
        const selectedService = this.servicesDealerList.find((service) => service.id === this.form.service_id);
        this.form.folios = selectedService.cantidad;
        this.disabledAcceptTransaccion = false;
      },
      debounceInput: _.debounce(function d(e) {
        this.search = e;
      }, 500),
      hasActionsSlot() {
        return !!this.$scopedSlots.actions;
      },
      refreshTable() {
        this.getDataFromApi()
        .then((data) => {
          this.items = data.items;
          this.totalItems = data.total;
        });
      },
      getDataFromApi() {
        this.loading = true;
        return new Promise(async (resolve) => {
          const {
            sortBy,
            sortDesc,
            page,
            itemsPerPage,
          } = this.options;
          const response = await this.getItems(page, itemsPerPage, sortBy, sortDesc).then((response) => {
              const data = response.data.items;
              const { total } = response.data;
              return ({ data, total } || []);
          });
          const items = response.data;
          const { total } = response;

          setTimeout(() => {
            this.loading = false;
            resolve({
              items,
              total,
            });
          }, 1000);
        });
      },
      getItems(page, itemsPerPage, sortBy, sortDesc) {
        const url = `${this.apiURL}?currentPage=${page}&perPage=${itemsPerPage}
        &search=${this.search}&sortBy=${sortBy}&desc=${sortDesc}${this.queryParams}`;
        const promise = window.axios.get(url).then();
        return promise;
      },
      newItem() {
        this.$router.push({ path: `${this.$router.currentRoute.path}/agregar` });
      },
      editItem(item) {
        const editedItem = { ...item };
        this.$router.push({ path: `${this.$router.currentRoute.path}/${editedItem.id}/editar`, params: { id: editedItem.id } });
      },
      historyItem(item) {
        const historyItem = { ...item };
        this.$router.push({ path: `${this.$router.currentRoute.path}/${historyItem.id}/historial`,
          params: { idHistory: historyItem.id } });
      },
      getXML(item) {
        const getItem = { ...item };
          const url = `/api/documents/${getItem.cufe}/xml`;
          window.axios({
            method: 'get',
            url,
          }).then((response) => {
            this.busy = true;
            if (response.data) {
              this.downloadFile(response, `${getItem.cufe}`);

              setTimeout(() => { this.dowloading = false; }, 1000);

               this.$store.dispatch('notifications/show', {
                message: 'Se ha descargado el XML con éxito.',
                type: 'success',
              });
              this.busy = false;
            } else {
              this.$store.dispatch('notifications/show', {
                message: 'El documentos no contiene XML.',
                type: 'error',
              });
              this.busy = false;
            }
          })
          .catch(() => {
          });
      },
      downloadFile(response, filename) {
      // Es necesario crear un nuevo objeto blob con mime-type establecido explícitamente
      // de lo contrario, solo Chrome funciona como debería  //application/vnd.ms-excel
      // application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
      const newBlob = new Blob([response.data], { type: 'xml' });
      // IE no permite usar un objeto blob directamente como enlace href, en su lugar, es necesario usar msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      // Para otros navegadores: Cree un enlace que apunte al ObjectURL que contiene el blob..
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      link.href = data;
      link.download = `${filename }.xml`;
      link.click();
      setTimeout(() => {
        // Para Firefox es necesario retrasar la revocación de ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },
      openModalDelete(item) {
       this.dialog = true;
       this.item = item;
      },
      deleteItem() {
        this.toggleStatusDelete = true;
        const url = `${this.apiURL}/${this.item.id}`;
        window.axios.delete(url)
        .then((response) => {
          this.$store.dispatch('notifications/show', {
            message: response.data.message,
            type: response.data.type,
          });
          this.toggleStatusDelete = false;
          this.dialog = false;
          this.getDataFromApi()
          .then((data) => {
            this.items = data.items;
            this.totalItems = data.total;
          });
        });
      },
      openModalMovements(item) {
        this.dialogShowMovements = true;
        this.item = item;
        this.titleAccount = item.razonSocial || '';
        this.licenseConversionQuantity = '';
      },
      generateMovement() {
        if (this.form.type_movement === 4) {
          this.syncConversionFoliosTotal();
          this.form.max_licenses_conversion = this.maxLicensesConversion;
        } else {
          this.form.max_licenses_conversion = '';
        }
        if (this.$refs.form.validate()) {
          this.form.busy = true;
          const url = '/api/history/store';
          window.axios.post(url, {
            folios: this.form.folios,
            description: this.form.description,
            type_movement: this.form.type_movement,
            service: this.form.service_id,
            max_licenses_conversion: this.form.max_licenses_conversion,
            outgoing_account_id: this.item.id,
            incoming_account_id: this.dealer.incoming_account_id,
            dealer_id: this.item.dealer_id,
          })
          .then((response) => {
            this.type = response.data.type;
              this.message = response.data.message;
              this.form.busy = false;
            if (this.type === 'success') {
              this.dialogShowMovements = false;
              this.resetForm();
              this.refreshTable();
            } else {
              this.dialogShowMovements = true;
              if (this.form.type_movement === 4) {
                this.syncConversionFoliosTotal();
              } else {
                this.form.folios = '';
              }
            }
          });
        }
      },
      resetForm() {
        this.$refs.form.reset();
        this.licenseConversionQuantity = '';
      },
      searchDealerAccount() {
        if (this.form.account_ruc_dealer) {
          this.searching = true;
          const url = `/api/getAccount/${this.form.account_ruc_dealer}`;
          window.axios.get(url)
          .then((response) => {
            if (response.data.type === 'success') {
                this.dealer.ruc = response.data.item.identificacion;
                this.dealer.razonSocial = response.data.item.razonSocial;
                this.dealer.account_number = response.data.item.account_number;
                this.dealer.incoming_account_id = response.data.item.id;
                this.disabledAcceptTransaccion = false;
            }
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.searching = false;
          });
        } else {
          this.$store.dispatch('notifications/show', {
            message: 'Introduzca un número de identificación.',
            type: 'error',
          });
        }
      },
      reset() {
        this.search = '';
      },
      openModalStatus(item) {
       this.dialogStatus = true;
       this.item = item;
      },
      toggleActive() {
        this.toggleStatus = true;
        const url = `${this.apiURL}/${this.item.id}/toggle`;
        window.axios.post(url)
          .then((response) => {
            this.refreshTable();
            this.toggleStatus = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.type = response.data.type;
            this.dialogStatus = false;
            this.item.active = !this.item.active;
          });
      },
      goBack() {
        if (this.backURL) { this.$router.push({ name: this.backURL }); } else { this.$router.go(-1); }
      },
      getColor(status) {
        if (status.indexOf('0260') !== -1) return 'green';
        return 'red';
      },
      getDate() {
        const date = new Date();
        const y = date.getFullYear();
        const m = (date.getMonth() + 1 < 10) ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const d = (date.getDate() < 10) ? `0${date.getDate()}` : date.getDate();
        const fecha = `${y}-${m}-${d}`;
      //  console.log(fecha);
        return fecha;
    },
    },
  };
</script>

<style scoped>
/* Stepper unificado (estilo moderno tipo “pill”) */
.license-qty-modern {
  max-width: 17.5rem;
  min-height: 52px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow:
    0 1px 2px rgba(60, 64, 67, 0.12),
    0 2px 6px rgba(60, 64, 67, 0.08);
  transition:
    box-shadow 0.2s ease,
    border-color 0.2s ease;
}

.license-qty-modern:focus-within {
  border-color: rgba(25, 118, 210, 0.45);
  box-shadow:
    0 1px 2px rgba(25, 118, 210, 0.12),
    0 4px 12px rgba(25, 118, 210, 0.12);
}

.license-qty-modern__btn {
  min-width: 48px !important;
  width: 48px;
  height: auto !important;
  min-height: 52px !important;
  border-radius: 0 !important;
  flex-shrink: 0;
}

.license-qty-modern__btn:hover:not(:disabled) {
  background: rgba(25, 118, 210, 0.06) !important;
}

.license-qty-modern__divider {
  align-self: stretch;
  margin: 8px 0 !important;
  border-color: rgba(0, 0, 0, 0.08) !important;
  opacity: 1;
}

.license-qty-modern__field-wrap {
  min-width: 0;
}

.license-qty-field {
  width: 100%;
  max-width: 5.5rem;
}

.license-qty-field >>> .v-input__control {
  min-height: 52px;
}

.license-qty-field >>> .v-input__slot {
  min-height: 52px !important;
  margin-bottom: 0 !important;
  padding: 0 4px !important;
  background: transparent !important;
}

.license-qty-field >>> input[type='number'] {
  text-align: center;
  font-size: 1.375rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.25;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
  color: rgba(0, 0, 0, 0.87);
}

.license-qty-field >>> input[type='number']::-webkit-outer-spin-button,
.license-qty-field >>> input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.license-qty-field >>> input[type='number'] {
  appearance: textfield;
  -moz-appearance: textfield;
}
</style>
